import React, { ReactElement, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { Box, Typography } from "@mui/material";
import { Translate } from "react-redux-i18n";

import Search from "components/shared/Search";
import { Provider, ProviderGame, getGameRequested, setSearchMenu } from "redux/games/gamesSlice";
import { checkWalletPermissions, handleScroll } from "services/utils";
import styles from "./styles.module.scss"

function CasinoLiveGamesSearch(): ReactElement {
  const dispatch = useAppDispatch()
  const providers = useAppSelector(state => state.games.casinoLive?.providers)
  const isAuth = useAppSelector((state) => state.auth.isAuth);
  const permissions = useAppSelector((state) => state.auth.permissions);
  const [searchValue, setSearchValue] = useState<string>("")
  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false)
  const [filteredGames, setFilteredGames] = useState<any>(undefined)
  const [gamesToShow, setGamesToShow] = useState<number>(50)


  const allGamesArray = providers?.map((provider: Provider) => {
    return provider?.games?.map((game: ProviderGame) => {
      const providerName = provider.name;
      const providerId = provider.id;
      const gameProps = Object.assign({ providerName, providerId }, game);
      return gameProps;
    });
  })
    .flat();


  const handleGameClick = (id?: number) => {
    isAuth &&
      id &&
      permissions &&
      checkWalletPermissions(permissions, "game.start_game") &&
      dispatch(getGameRequested(id))
  }

  useEffect(() => {
    if (searchValue.length > 0) {
      allGamesArray &&
        setFilteredGames(
          allGamesArray
            .filter(game =>
              game &&
              game.label?.toLowerCase().includes(searchValue.toLowerCase())))
    } else {
      setFilteredGames(undefined)
    }
  }, [searchValue])

  useEffect(() => {
    if (filteredGames && filteredGames.length > 0) {
      dispatch(setSearchMenu(true))
    } else {
      dispatch(setSearchMenu(false))
    }
  }, [filteredGames])


  return (
    <Box className={styles.searchGamesContainer}>
      <Search
        label="sarchCasino"
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        autoFocus={true}
        showIcon={true}
        showMenu={setIsMenuVisible}
        isMenuVisible={isMenuVisible}
        caller="casino"
      />
      {searchValue?.length > 0 &&
        <Box
          onScroll={(e) => {
            handleScroll(e, setGamesToShow, gamesToShow, 50)
          }}
          className={styles.filteredMenu}>
          {
            filteredGames?.length > 0 ?
              filteredGames.slice(0, gamesToShow).map((item: ProviderGame) => (
                <Box
                  key={item?.id}
                  onClick={() => handleGameClick(item?.id)}
                  className={styles.gameContainer}
                >
                  <img src={item?.icon} className={styles.gameIcon} />
                  <Typography className={styles.gameLabel}>{item?.label}</Typography>
                </Box>
              ))
              :
              <Typography className={styles.noGameText}><Translate value="casino.noSearchResult" /></Typography>
          }
        </Box>
      }
    </Box>
  )
}

export default CasinoLiveGamesSearch